module.exports = __webpack_public_path__ + "static/media/headerLogoDelfos.6ec2da0b.svg";